import React from "react";
import EditionSecondRef from "../../Partials/Reports/EditionSecondRef";

const ListReportEdition = () => {
  return <EditionSecondRef email />;
};

export default ListReportEdition;
